import React from 'react';
import { connect } from 'react-redux'
import { branch, compose, renderComponent } from 'recompose'
import { eventActions, eventSelectors} from './redux'
import { sessionSelectors } from '../session/redux'
import lifeCycle from './EventListLifecycle'
import EventList from "./EventList";
import Loading from '../../components/Loading'
import {careUnitActions, careUnitSelectors} from "../careUnit/redux";
import {opticianActions, opticianSelectors} from "../optician/redux";

const mapStateToProps = (state) => ({
  events: eventSelectors.eventList(state),
  filter: eventSelectors.eventListFilter(state),
  careUnits: careUnitSelectors.careUnitList(state),
  opticians: opticianSelectors.opticianList(state),
  loggedInUser: sessionSelectors.loggedInUser(state),
  errorMessage: eventSelectors.errorMessage(state),
  isLoading: eventSelectors.isLoading(state),
  selectedEvent: eventSelectors.selectedEvent(state),
  detailDialogOpen: eventSelectors.detailDialogOpen(state),
  currentPage: eventSelectors.currentPage(state),
  totalPages: eventSelectors.totalPages(state),
  totalElements: eventSelectors.totalElements(state),
  statusCounts: eventSelectors.statusCounts(state),
});

const mapDispatchToProps = (dispatch) => ({
  listEvents: (page) => dispatch(eventActions.listEvents(page)),
  listCareUnits: () => dispatch(careUnitActions.listCareUnits()),
  listOpticians: () => dispatch(opticianActions.listOpticians()),
  updateEventListFilter: (filter) => {
    dispatch(eventActions.updateEventListFilter(filter));
    dispatch(eventActions.listEvents(0))
  },
  onPageChange: (page) => dispatch(eventActions.listEvents(page)),
  openEventDetailDialog: (event) => dispatch(eventActions.openEventDetailDialog(event)),
  closeEventDetailDialog: () => dispatch(eventActions.closeEventDetailDialog()),
});

export default compose (
    connect(mapStateToProps, mapDispatchToProps),
    lifeCycle,
    branch(({isLoading, events, errorMessage}) => isLoading || (!events && !errorMessage),
        renderComponent(()=><Loading title={'Laddar...'}/>)
    )
)(EventList)